import DsModal from '@/common/DsModal';

type OwnProps = {
  isOpen: boolean;
  description?: string;
  videoUrl: string;
  onClose: () => void;
};

export default function VideoModal({
  isOpen,
  description,
  videoUrl,
  onClose
}: OwnProps) {
  return (
    <DsModal
      isOpen={isOpen}
      onClose={() => onClose()}
      divLine={false}
      mobileStyle="inset"
      className="w-[90%] sm:max-w-[704px] md:max-w-[1056px]"
      data-testid="shaqvana-video-modal"
    >
      <div className="flex aspect-video flex-col items-start gap-0 self-stretch p-0">
        <iframe
          className="h-full w-full"
          title={description || 'Video Modal'}
          src={videoUrl}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          data-testid="shaqvana-video-iframe"
        />
      </div>
    </DsModal>
  );
}
